import { useEffect, useState, useRef } from "react";
import style from "./style.module.scss";

import SearchBar from "../PageCovers/SearchBar";

function VideoPlayer({ full }) {
  const [miniSize, setMiniSize] = useState(false);
  const video = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!miniSize) {
          if (entry.isIntersecting) {
            video.current.play();
          } else {
            // if (!video.current?.paused) setMiniSize(true);
          }
        } else {
        }
      });
    });

    // console.log("ELEMENT", video);

    observer.observe(video.current);
  }, []);

  return (
    <div
      className={
        "row align-items-center " +
        (miniSize ? style.VideoPlayerMini : style.VideoPlayer)
      }
      style={full && !miniSize ? { width: "100vw" } : {}}
    >
      <div className={style.videoCnt}>
        {!miniSize && (
          <>
            <div className={style.logoCnt}>
              <img
                className={style.logo}
                src="/Images/infopages/common/videoplayer/logo.png"
              />
            </div>
            <div className={style.textCnt + " " + style.fadeIn}>
              <div className={style.content}>
                <SearchBar />
              </div>
            </div>
          </>
        )}

        <video
          ref={video}
          muted
          id="videplayer_video"
          style={full && !miniSize ? { height: "calc(100vh)" } : {}}
          src="/Videos/vhenga.mp4"
          className={style.video}
          controls
          preload="false"
          playsInline={true}
        ></video>
        {miniSize && (
          <div
            className={style.x}
            onClick={(e) => {
              video.current.pause();
              setMiniSize(false);
            }}
          >
            <div>x</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VideoPlayer;
